import {AutoTextSize} from "auto-text-size";
import React from "react";
import {isMobile} from "react-device-detect";

function DailyTask({task}: any ) {
    const progress = JSON.parse(task.progress);
    const reward = JSON.parse(task.reward);
    let text = task.text;
    text = text.replace("%num%", progress.need);

    let minFontSize = 16;
    if(isMobile){
        minFontSize = 14;
    }

    return <div  className={'dailyTask'}>
        <div className={'dailyTaskLeft'}>
            <div className={'dailyTaskProgress'}>{progress.done}/{progress.need}</div>
            <div className={'dailyTaskText'}><AutoTextSize mode={'box'} minFontSizePx={minFontSize}
                                                           maxFontSizePx={16}>{text}</AutoTextSize></div>
        </div>
        <div className={'dailyTaskRight'}>
            <div className={'dailyTaskGem'}></div>
            <div className={'dailyTaskReward'}>{reward.gems}</div>
        </div>
    </div>

}

export default DailyTask;